<template>
    <div :class="{'pointer-events-none': exportLoading || isLoadingResult }" class="flex flex-col">
        <div class="flex h-[72px] items-center bg-grey-10 px-3 py-4 text-base font-semibold text-black ">
            <IconIdea class="mr-2"/>
            {{ $t('idea') }}
        </div>

        <div class="relative flex grow flex-col justify-center p-3 pb-[60px]">
            <InputFilter :filterErrorStatus="filterErrorStatus"/>
            <div class="mt-4 flex grow flex-col" ref="inputArea">

                <!-- means -->
                <div class="left-content-input flex grow flex-col">
                    <div class="flex items-center gap-2">
                        <div class="h-3 w-1 rounded-xl bg-eureka-500"></div>
                        <p class="text-sm text-black">{{$t('means')}}
                            <span class="text-red-500">*</span>
                        </p>
                    </div>

                    <TextareaEditor v-model="editContent.means"
                                    :warningNumber="50"
                                    class="mt-2 w-full grow"
                                    :class="{'textarea-outline-x-error': !meansValid,'textarea-outline-x-warning': editContent.means.length<50}"
                                    :placeholder="$t('meansPlaceholder')"
                    />
                </div>

                <!-- efficacy -->
                <div class="left-content-input flex grow flex-col">
                    <div class="mt-4 flex items-center gap-2">
                        <div class="h-3 w-1 rounded-xl bg-eureka-500"></div>
                        <p class="text-sm text-black">{{$t('efficacy')}}</p>
                    </div>
                    <TextareaEditor v-model="editContent.efficacy"
                                    :warningNumber="10"
                                    class="w-ful mt-2 grow"
                                    :class="{'textarea-outline-x-error': !efficacyValid,'textarea-outline-x-warning': editContent.efficacy.length<10}"
                                    :placeholder="$t('efficacyPlaceholder')"
                    />
                </div>

            </div>

            <div class="mt-3 flex items-center">

                <button @click="handleFillExample" v-if="!haveResult" class="flex h-5 w-max min-w-[80px] shrink-0 items-center justify-center rounded-xl border border-dotted border-eureka-500 px-4 py-0.5 text-xs text-eureka-500 hover:bg-blue-40 hover:text-eureka-700">
                    {{ $t('fill') }}
                </button>

                <div class="ml-auto flex shrink-0">
                    <div :class="{' cursor-not-allowed': searchBtnDisable || isLoadingResult}">
                        <button class="th-btn mr-2" :class="{'th-btn-outline': haveResult}" @click="submitCheck"
                                :disabled="searchBtnDisable || isLoadingResult"
                        >
                            <IconSearch class="th-btn-icon"/>
                            <span>{{ reCheckStatus ? $t('research') : $t('search')}}</span>
                        </button>
                    </div>

                    <button @click="downloadDisclosure" class="th-btn mr-2 min-w-[160px]"
                            :disabled="exportLoading"
                            v-if="haveResult && downloadPermission">
                        <IconGenerate class="th-btn-icon"/>
                        <span v-if="exportLoading" class="th-loading th-loading-spinner th-loading-xs"></span>
                        <span v-else>{{ $t('downloadDisclosure') }}</span>
                    </button>

                </div>

            </div>

            <p v-if="isReportPage" class="absolute bottom-2 w-full text-center text-xs text-grey-90">{{ $t('generationTip') }}</p>
        </div>

    </div>
</template>

<script setup lang="ts">
import IconSearch from '@/components/icons/IconSearch.vue'
import IconGenerate from '@/components/icons/IconGenerate.vue'
import IconIdea from '@/components/icons/IconIdea.vue'
import TextareaEditor from '@/components/TextareaEditor.vue'
import { useIdeaInput } from '@/composables/use-idea-input';
import { useGlobalState } from '@/composables/use-global-store';
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router';
import InputFilter from '@/components/InputFilter.vue'

const inputArea = ref(null)
const route = useRoute()

const isReportPage = computed(() => route.name === 'report')

const { editContent } = useGlobalState();
const { searchBtnDisable, filterErrorStatus, exportLoading, efficacyValid, meansValid, isLoadingResult, haveResult, submitCheck, reCheckStatus, handleFillExample, downloadPermission, downloadDisclosure } = useIdeaInput()
</script>
